import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import configureStore from './store';
import 'whatwg-fetch';

import './styles/reset.scss';
import './styles/index.scss';
import routes from './routes';

const history = createHistory();
const store = configureStore(history, {});
ReactDOM.render(
    <Provider store = {store} key="provider">
	    <ConnectedRouter history={history}>
			{routes()}
		</ConnectedRouter>
    </Provider>, document.getElementById('main-container')
);

if(process.env.NODE_ENV !== "production") {
    window.React = React; // enable debugger
}



// WEBPACK FOOTER //
// ./src/index.js